import { Injectable } from '@angular/core';
import { ImageUtils } from './image-utils';

@Injectable({
  providedIn: 'root',
})
export class WindowService {
  constructor() {
    // Assign the DB changes handler to the global window object
    window.onchange = (evt: Event) => {
      console.log('DB Change event received:', evt);
    };

    // Add imageUtils
    window.imageUtils = new ImageUtils();
  }
}
